export default {
  namespaced: true,
  state: {
    deleteAccount:{
        show:false,
    }
  },
  getters: {
    getShow:(state)=>state.deleteAccount.show
  },
  mutations: {
    TOGGLE_DELETE_ACCOUNT(state,obj){
        state.deleteAccount.show = obj.show
    }
  },
  actions: {
    toggleDeleteAccount({commit},obj){
        commit("TOGGLE_DELETE_ACCOUNT",obj)
    }
  },
};
